export default "__VITE_ASSET__qvrqV1s4__"